"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScreenReadersUtilities = getScreenReadersUtilities;
exports.default = void 0;

var _screenReader = require("@bootstrap-styled/css-mixins/lib/screen-reader");

function getScreenReadersUtilities() {
  return "\n    .sr-only {\n      ".concat((0, _screenReader.srOnly)(), "\n    }\n    \n    .sr-only-focusable {\n      ").concat((0, _screenReader.srOnlyFocusable)(), "\n    }\n  ");
}

var _default = {
  getScreenReadersUtilities: getScreenReadersUtilities
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bootstrap-styled/css-utils/lib/screenreaders.js
// module id = 131
// module chunks = 0